import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowLeft, ArrowRight, Menu, Network, X } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const Brand = ({ sub = true }) => {
  const { t } = useLang();
  return (
    <Link to="/" className="brand" data-testid="brand-home">
      <span className="brand-mark"><Network size={22} /></span>
      <span className="brand-text"><b>RESEARCH</b><em>NETWORK</em>{sub && <span className="brand-sub">{t.brandSub}</span>}</span>
    </Link>
  );
};

export const Header = () => {
  const { t, rtl, lang, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  const links = [
    { to: "/", label: t.nav.home, end: true },
    { to: "/opportunities", label: t.nav.opportunities },
    { to: "/achievements", label: t.nav.achievements },
    { to: "/coordinator", label: t.nav.coordinator },
    { to: "/my", label: t.nav.my },
  ];
  const renderLink = (l, i) => l.hash
    ? <a href={l.to} key={l.to} data-testid={`nav-link-${i}`} onClick={() => setOpen(false)}>{l.label}</a>
    : <NavLink to={l.to} end={l.end} key={l.to} data-testid={`nav-link-${i}`} onClick={() => setOpen(false)} className={({ isActive }) => (isActive ? "active" : "")}>{l.label}</NavLink>;

  return (
    <header className="header" data-testid="site-header">
      <div className="container">
        <div className="header-inner">
          <Brand />
          <nav className="nav" data-testid="main-navigation">{links.map(renderLink)}</nav>
          <div className="header-actions">
            <button className="lang-toggle" onClick={toggle} data-testid="language-toggle">{lang === "ar" ? "EN" : "عربي"}</button>
            <Link to="/opportunities" className="btn btn-primary btn-sm desktop-only" data-testid="nav-register-button">{t.opps.register}<Arrow size={16} /></Link>
            <button className="menu-btn" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="menu">{open ? <X size={20} /> : <Menu size={20} />}</button>
          </div>
        </div>
        {open && <nav className="mobile-nav" data-testid="mobile-navigation">{links.map(renderLink)}</nav>}
      </div>
    </header>
  );
};
